import i18n from '@i18n';
import { formatDateOverview } from '@/common/client';

const betInfo = ({ betNumber, betName, sportName, tournamentName, tournamentNote, opponents, start }) =>
    [
        betNumber && `${i18n('SEARCH_MATCH_NUM')}: ${betNumber}`,
        sportName,
        tournamentName,
        tournamentNote,
        opponents &&
            (opponents.length > 1
                ? `${opponents[0]} ${i18n('homeAway.vs.separator')} ${opponents[1]}`
                : `${opponents[0]}`),
        betName,
        start && formatDateOverview(start)
    ]
        .filter(Boolean)
        .join(' | ');

export default betInfo;
